import { createCombineMapItem } from '../../../../../reducerRegistry';

import { createReduceObject as createObjectCollectionReduceObject } from '../../../../../common/reducers/objectCollection/reducer';
import faqContentCollectionSaga from './sagas/faqContentCollectionSaga';

export default [
  ...createCombineMapItem(
    'faqContentCollection',
    createObjectCollectionReduceObject,
    [faqContentCollectionSaga]
  )
];



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/faqContents/reducers/static/collections/reducersMap.js